/**
 * The type of the file to store.
 */
export enum StorageFileType {
  /**
   * JPG (JPEG) - Joint Photographic Experts Group.
   */
  JPG = 'jpg',

  /**
   * PNG - Portable Network Graphic.
   */
  PNG = 'png',

  /**
   * GIF - Graphics Interchange Format.
   */
  GIF = 'gif',

  /**
   * DICOM - Digital Imaging and Communications in Medicine.
   */
  DICOM = 'dicom',

  /**
   * TIFF - Tagged Image File Format.
   */
  TIFF = 'tiff',

  /**
   * MOV - Apple QuickTime Movie.
   */
  MOV = 'mov',

  /**
   * MP4 - MPEG-4 Part 14.
   */
  MP4 = 'mp4',

  /** WebM video. */
  WebMVideo = 'webm-video',

  /**
   * MP3 - MPEG-1 Audio Layer III.
   */
  MP3 = 'mp3',

  /**
   * WAV - Waveform Audio File Format.
   */
  WAV = 'wav',

  /**
   * PDF - Portable Document Format.
   */
  PDF = 'pdf',

  /**
   * DOC - Microsoft Word.
   */
  DOC = 'doc',

  /**
   * DOCX - Microsoft Word.
   */
  DOCX = 'docx',

  /**
   * TXT - Text.
   */
  TXT = 'txt',

  /**
   * XLS - Microsoft Excel.
   */
  XLS = 'xls',

  /**
   * XLSX - Microsoft Excel.
   */
  XLSX = 'xlsx',

  /**
   * CSV - Comma-Separated Values.
   */
  CSV = 'csv',

  /**
   * PPT - Microsoft PowerPoint.
   */
  PPT = 'ppt',

  /**
   * PPTX - Microsoft PowerPoint.
   */
  PPTX = 'pptx',
}
